/** @format */

import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { DbService } from 'src/app/core/services/db.service';
import { map, take } from 'rxjs/operators';
import * as moment from 'moment';
import * as firebase from 'firebase';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/core/services/data.service';
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
  element;
  configData;
  cookieValue;
  flagvalue;
  countryName;
  valueset;

  uid;
  alarm;
  allList = 0;
  alarm$: any;
  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    public _cookiesService: CookieService,
    private db: DbService,
    private dataService: DataService
  ) {}
  listLang = [
    { text: '한국어', lang: 'ko' },
    { text: '영어', lang: 'en' },
  ];
  // listLang = [
  //   { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
  //   { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
  //   { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
  //   { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
  //   { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  // ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  @ViewChildren('alarmDrop') alarmDrop: QueryList<NgbDropdown>;

  async ngOnInit() {
    await this.dataService.initialData();
    this.uid = await this.authService.getUser();

    this.alarm$ = await this.getAlarmData();

    this.openMobileMenu = false;
    this.element = document.documentElement;

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.cookieValue = this._cookiesService.get('lang');
    if (!this.cookieValue) {
      this.cookieValue = 'ko';
      this._cookiesService.set('lang', 'ko');
    }
    this.changeListLangText(this.cookieValue);
    const val = this.listLang.filter((x) => x.lang === this.cookieValue);
    this.countryName = val.map((element) => element.text);

    // this.cookieValue = this._cookiesService.get('lang');
    // const val = this.listLang.filter(x => x.lang === this.cookieValue);
    // this.countryName = val.map(element => element.text);
    // if (val.length === 0) {
    //   if (this.flagvalue === undefined) {
    //     this.valueset = 'assets/images/flags/us.jpg';
    //   }
    // } else {
    //   this.flagvalue = val.map(element => element.flag);
    // }
  }

  changeListLangText(value: string) {
    if (value === 'ko') {
      this.listLang[0].text = '한국어';
      this.listLang[1].text = '영어';
    } else {
      this.listLang[0].text = 'Korean';
      this.listLang[1].text = 'English';
    }
  }

  // setLanguage(text: string, lang: string, flag: string) {
  //   this.countryName = text;
  //   this.flagvalue = flag;
  //   this.cookieValue = lang;
  //   this.languageService.setLanguage(lang);
  // }
  setLanguage(lang: string, i: number) {
    this.changeListLangText(lang);
    this.countryName = this.listLang[i].text;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Logout the user
   */
  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
      this.db.updateAt(`users/${this.uid}`, { msWebPushId: '' });
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(['/account/login']);
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  getAlarmData() {
    return this.db
      .collection$(`masterNotices`, (ref) => ref.orderBy('dateCreated', 'desc'))
      .pipe(
        map((notices: any) => notices.filter((item) => !item.confirmSwitch)),
        map((notices: any) => {
          console.log('notices', notices);

          this.allList = 0;
          notices
            .filter((notice) => !!notice.senderId)
            .map(async (notice: any) => {
              if (notice.type == 'user') {
                const data = await this.db
                  .doc$(`users/${notice.senderId}`)
                  .pipe(take(1))
                  .toPromise();
                notice.name = data.name ? data.name : '';
              } else {
                const data = await this.db
                  .doc$(`studios/${notice.senderId}`)
                  .pipe(take(1))
                  .toPromise();
                notice.name = data.studioName ? data.studioName : '';
              }
              if (notice.checkMasterList.length > 0) {
                if (
                  notice.checkMasterList.filter((ele) => ele == this.uid.uid)
                    .length <= 0
                ) {
                  notice.confirmSwitch = false;
                } else {
                  notice.confirmSwitch = true;
                }
              } else {
                notice.confirmSwitch = false;
              }

              return notice;
            });
          let now = moment().format('YYYY-MM-DD');
          let recent3Month = moment(new Date(now))
            .subtract(3, 'M')
            .format('YYYY-MM-DD');
          return notices.filter(
            (ele) =>
              moment(new Date(ele.dateCreated)).format('YYYY-MM-DD') <= now &&
              moment(new Date(ele.dateCreated)).format('YYYY-MM-DD') >=
                recent3Month
          );
        }),
        map((data) => {
          console.log('data', data);

          this.allList = data.length;
          return data;
        })
      );
  }

  async goExchange(list) {
    console.log('list', list);
    if (list.text && list.text === '에서 정산신청을 하였습니다.') {
      await this.db.updateAt(`masterNotices/${list.id}`, {
        confirmSwitch: true,
      });
      this.alarmDrop.toArray()[0].close();
      this.router.navigate(['/exchange-detail']);
    }
  }

  async checkDropDown(open: boolean) {
    console.log(open);
    if (!open) {
      this.alarm$.pipe(take(1)).subscribe((data) => {
        console.log('data :', data);
        data.forEach((element) => {
          if (element && !element.checkMasterList.includes(this.uid.uid)) {
            console.log(element);
            this.db.updateAt(
              `masterNotices/${
                element.masternoticeId ? element.masternoticeId : element.id
              }`,
              {
                checkMasterList:
                  firebase.default.firestore.FieldValue.arrayUnion(
                    this.uid.uid
                  ),
              }
            );
          }
        });
      });
      this.alarm$ = await this.getAlarmData();
    }
  }
}
